/** Canonical public VISI profile host — matches iOS `PublicProfileWebsite`. */
export const PUBLIC_PROFILE_BASE = 'https://visi.me';

export function normalizePublicUsername(raw: string | undefined | null): string {
  let username = (raw || '').trim();
  while (username.startsWith('@') || username.startsWith('/')) {
    username = username.slice(1);
  }
  return username;
}

/** Build `https://visi.me/{username}` for QR / share / copy (parity with iOS). */
export function publicProfileUrl(rawUsername: string | undefined | null): string {
  const username = normalizePublicUsername(rawUsername);
  if (!username) return PUBLIC_PROFILE_BASE;
  return `${PUBLIC_PROFILE_BASE}/${encodeURIComponent(username)}`;
}
